import firebase from 'firebase/app';
import 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://pre1-elec-soldig.firebaseio.com',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

const firebaseConfig2 = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://pre2-elec-soldig.firebaseio.com',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

const firebaseConfig3 = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://pre3-elec-soldig.firebaseio.com',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

const firebaseBackup = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciosdes-tvbackup.firebaseio.com/',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

export default () => {
  return {
    app1: firebase.initializeApp(firebaseConfig, 'db1'),
    app2: firebase.initializeApp(firebaseConfig2, 'db2'),
    app3: firebase.initializeApp(firebaseConfig3, 'db3'),
    appBackup: firebase.initializeApp(firebaseBackup, 'dbBackup'),

    firebase
  };
};
